import React from 'react'
import PropTypes from 'prop-types'
import './styles.css'

const Category = ({ header, items }) => (
  <div className='category'>
    <div className='header'>{header}</div>
    {items && items.map(item => (
      <div className='item' key={item.a}>
        <a href={item.a} target='_blank' className='itemHeader'>{item.header}</a>
        <div className='itemInfo'>{item.info}</div>
        {item.body && <div className='itemBody'>{item.body}</div>}
      </div>
    ))}
  </div>
)

Category.propTypes = {
  header: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    info: PropTypes.string,
    a: PropTypes.string,
  })).isRequired,
}

export default Category



// WEBPACK FOOTER //
// ./src/components/Category/index.js